export const dateReviver = (key: string, value: any): Date | string =>
('string' === typeof value && /^\d{4}-[01]\d-[0-3]\dT[012]\d(?::[0-5]\d){2}\.\d+\+[0-2]\d:[0-5]\d$/.test(value)) ?
    new Date(value) : value;
